import React from 'react';
import cx from 'classnames';

import { AppRoutes } from 'app/static/routes/routes-enum';
import Button from 'app/components/ui/Button';
import TokenImage from 'app/components/ui/TokenImage';
import { prettyPrice } from 'app/utils/helpers';
import { useCurrency } from 'app/context/CurrencyContext';

import s from './EquivalentPairInfo.module.sass';

type EquivalentPairInfoProps = {
  className?: string
  id: string
  image: string | null
  name: string
  price: number
  equivalentTokenValue: string
  equivalentTokenName: string
  loading?: boolean
  tokenId?: string
};

const EquivalentPairInfo: React.FC<EquivalentPairInfoProps> = ({
  className,
  id,
  image,
  name,
  price,
  equivalentTokenValue,
  equivalentTokenName,
  loading,
  tokenId,
}) => {
  const { xtzUsdQuote } = useCurrency();

  const tokenPriceInUsd = name !== 'XTZ' ? prettyPrice(price * xtzUsdQuote) : prettyPrice(price);

  const url = tokenId ? `${AppRoutes.TOKENS}/${id}_${tokenId}` : `${AppRoutes.TOKENS}/${id}`;

  return (
    <div className={cx(s.root, className)}>
      <div className={cx(s.wrapper, { [s.paddingBottom]: loading })}>
        <TokenImage
          firstTokenImage={image}
          sizeT="medium"
          tokensNames={{ firstTokenName: name ?? 'Token' }}
          className={cx(s.logo)}
        />

        {loading ? '...' : (
          <div className={cx(s.data)}>
            1
            &nbsp;
            {name}
            &nbsp;
            =
            &nbsp;
            {equivalentTokenValue}
            &nbsp;
            {equivalentTokenName}
            &nbsp;
            {`($ ${tokenPriceInUsd})`}
          </div>
        )}
      </div>

      {!loading && (
        <Button sizeT="small" theme="nonary" to={url}>
          See more
        </Button>
      )}
    </div>
  );
};

export default EquivalentPairInfo;
